export { OldVippsBanner } from "./OldVippsBanner";
